function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { timeline } from '../modules/core/defaults.js';
import { extend } from '../utils/adopter.js';
/***
Base Class
==========
The base stepper class that will be
***/ function makeSetterGetter(k, f) {
    return function(v) {
        if (v == null) return this[k];
        this[k] = v;
        if (f) f.call(this);
        return this;
    };
}
export var easing = {
    '-': function(pos) {
        return pos;
    },
    '<>': function(pos) {
        return -Math.cos(pos * Math.PI) / 2 + 0.5;
    },
    '>': function(pos) {
        return Math.sin(pos * Math.PI / 2);
    },
    '<': function(pos) {
        return -Math.cos(pos * Math.PI / 2) + 1;
    },
    bezier: function bezier(x1, y1, x2, y2) {
        // see https://www.w3.org/TR/css-easing-1/#cubic-bezier-algo
        return function(t) {
            if (t < 0) {
                if (x1 > 0) {
                    return y1 / x1 * t;
                } else if (x2 > 0) {
                    return y2 / x2 * t;
                } else {
                    return 0;
                }
            } else if (t > 1) {
                if (x2 < 1) {
                    return (1 - y2) / (1 - x2) * t + (y2 - x2) / (1 - x2);
                } else if (x1 < 1) {
                    return (1 - y1) / (1 - x1) * t + (y1 - x1) / (1 - x1);
                } else {
                    return 1;
                }
            } else {
                return 3 * t * Math.pow(1 - t, 2) * y1 + 3 * Math.pow(t, 2) * (1 - t) * y2 + Math.pow(t, 3);
            }
        };
    },
    // see https://www.w3.org/TR/css-easing-1/#step-timing-function-algo
    steps: function steps(steps) {
        var stepPosition = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'end';
        // deal with "jump-" prefix
        stepPosition = stepPosition.split('-').reverse()[0];
        var jumps = steps;
        if (stepPosition === 'none') {
            --jumps;
        } else if (stepPosition === 'both') {
            ++jumps;
        }
        // The beforeFlag is essentially useless
        return function(t) {
            var beforeFlag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            // Step is called currentStep in referenced url
            var step = Math.floor(t * steps);
            var jumping = t * step % 1 === 0;
            if (stepPosition === 'start' || stepPosition === 'both') {
                ++step;
            }
            if (beforeFlag && jumping) {
                --step;
            }
            if (t >= 0 && step < 0) {
                step = 0;
            }
            if (t <= 1 && step > jumps) {
                step = jumps;
            }
            return step / jumps;
        };
    }
};
export var Stepper = /*#__PURE__*/ function() {
    "use strict";
    function Stepper() {
        _class_call_check(this, Stepper);
    }
    _create_class(Stepper, [
        {
            key: "done",
            value: function done() {
                return false;
            }
        }
    ]);
    return Stepper;
}();
/***
Easing Functions
================
***/ export var Ease = /*#__PURE__*/ function(Stepper) {
    "use strict";
    _inherits(Ease, Stepper);
    function Ease() {
        var fn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : timeline.ease;
        _class_call_check(this, Ease);
        var _this;
        _this = _call_super(this, Ease);
        _this.ease = easing[fn] || fn;
        return _this;
    }
    _create_class(Ease, [
        {
            key: "step",
            value: function step(from, to, pos) {
                if (typeof from !== 'number') {
                    return pos < 1 ? from : to;
                }
                return from + (to - from) * this.ease(pos);
            }
        }
    ]);
    return Ease;
}(Stepper);
/***
Controller Types
================
***/ export var Controller = /*#__PURE__*/ function(Stepper) {
    "use strict";
    _inherits(Controller, Stepper);
    function Controller(fn) {
        _class_call_check(this, Controller);
        var _this;
        _this = _call_super(this, Controller);
        _this.stepper = fn;
        return _this;
    }
    _create_class(Controller, [
        {
            key: "done",
            value: function done(c) {
                return c.done;
            }
        },
        {
            key: "step",
            value: function step(current, target, dt, c) {
                return this.stepper(current, target, dt, c);
            }
        }
    ]);
    return Controller;
}(Stepper);
function recalculate() {
    // Apply the default parameters
    var duration = (this._duration || 500) / 1000;
    var overshoot = this._overshoot || 0;
    // Calculate the PID natural response
    var eps = 1e-10;
    var pi = Math.PI;
    var os = Math.log(overshoot / 100 + eps);
    var zeta = -os / Math.sqrt(pi * pi + os * os);
    var wn = 3.9 / (zeta * duration);
    // Calculate the Spring values
    this.d = 2 * zeta * wn;
    this.k = wn * wn;
}
export var Spring = /*#__PURE__*/ function(Controller) {
    "use strict";
    _inherits(Spring, Controller);
    function Spring() {
        var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 500, overshoot = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        _class_call_check(this, Spring);
        var _this;
        _this = _call_super(this, Spring);
        _this.duration(duration).overshoot(overshoot);
        return _this;
    }
    _create_class(Spring, [
        {
            key: "step",
            value: function step(current, target, dt, c) {
                if (typeof current === 'string') return current;
                c.done = dt === Infinity;
                if (dt === Infinity) return target;
                if (dt === 0) return current;
                if (dt > 100) dt = 16;
                dt /= 1000;
                // Get the previous velocity
                var velocity = c.velocity || 0;
                // Apply the control to get the new position and store it
                var acceleration = -this.d * velocity - this.k * (current - target);
                var newPosition = current + velocity * dt + acceleration * dt * dt / 2;
                // Store the velocity
                c.velocity = velocity + acceleration * dt;
                // Figure out if we have converged, and if so, pass the value
                c.done = Math.abs(target - newPosition) + Math.abs(velocity) < 0.002;
                return c.done ? target : newPosition;
            }
        }
    ]);
    return Spring;
}(Controller);
extend(Spring, {
    duration: makeSetterGetter('_duration', recalculate),
    overshoot: makeSetterGetter('_overshoot', recalculate)
});
export var PID = /*#__PURE__*/ function(Controller) {
    "use strict";
    _inherits(PID, Controller);
    function PID() {
        var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.1, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.01, d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, windup = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1000;
        _class_call_check(this, PID);
        var _this;
        _this = _call_super(this, PID);
        _this.p(p).i(i).d(d).windup(windup);
        return _this;
    }
    _create_class(PID, [
        {
            key: "step",
            value: function step(current, target, dt, c) {
                if (typeof current === 'string') return current;
                c.done = dt === Infinity;
                if (dt === Infinity) return target;
                if (dt === 0) return current;
                var p = target - current;
                var i = (c.integral || 0) + p * dt;
                var d = (p - (c.error || 0)) / dt;
                var windup = this._windup;
                // antiwindup
                if (windup !== false) {
                    i = Math.max(-windup, Math.min(i, windup));
                }
                c.error = p;
                c.integral = i;
                c.done = Math.abs(p) < 0.001;
                return c.done ? target : current + (this.P * p + this.I * i + this.D * d);
            }
        }
    ]);
    return PID;
}(Controller);
extend(PID, {
    windup: makeSetterGetter('_windup'),
    p: makeSetterGetter('P'),
    i: makeSetterGetter('I'),
    d: makeSetterGetter('D')
});
